import type {FilterBlock} from 'src/types/filter';
import type {FilterAction} from 'src/action-creators/filter';

import {
  createFilterBlockIdentifier,
  getDefaultFilterBlock,
} from 'src/utils/filter';
import {
  RECEIVE_FILTER,
  RESET,
  SET_RULES,
  ADD_BLOCK,
  SET_SCOPE,
  REMOVE_BLOCK,
} from 'src/action-creators/filter';


export type FilterState = {
  blocks: Map<string, FilterBlock>;
};

const initialState = {
  blocks: new Map(getDefaultFilterBlock()),
} as const;

export default (
  state: FilterState = initialState,
  action: FilterAction,
): FilterState => {
  switch (action.type) {
    case RECEIVE_FILTER: {
      const {blocks} = action.payload;
      return {
        ...state,
        blocks,
      };
    }
    case RESET: {
      return {...initialState};
    }
    case SET_RULES: {
      const {blockId, rules} = action.payload;
      const updatedMap = new Map(state.blocks);
      const currentEntry = updatedMap.get(blockId);
      if (currentEntry) {
        const updatedEntry = {
          rules,
          scope: currentEntry.scope,
        } as const;
        updatedMap.set(blockId, updatedEntry);
      }
      return {
        ...state,
        blocks: updatedMap,
      };
    }
    case SET_SCOPE: {
      const {blockId, scope} = action.payload;
      const updatedMap = new Map(state.blocks);
      const currentEntry = updatedMap.get(blockId);
      if (currentEntry) {
        const updatedEntry = {
          rules: currentEntry.rules,
          scope,
        } as const;
        updatedMap.set(blockId, updatedEntry);
      }
      return {
        ...state,
        blocks: updatedMap,
      };
    }
    case ADD_BLOCK: {
      const updatedMap = new Map(state.blocks);
      updatedMap.set(createFilterBlockIdentifier(), {rules: [], scope: null});
      return {
        ...state,
        blocks: updatedMap,
      };
    }
    case REMOVE_BLOCK: {
      const {blockId} = action.payload;
      const updatedMap = new Map(state.blocks);
      updatedMap.delete(blockId);
      return {
        ...state,
        blocks: updatedMap,
      };
    }
  }
  return state;
};
